// import React from "react";

import React from "react";

const SakhisSpecial = () => {
  return (
    <iframe
      src="/sakhis-special/index.html"
      title="Sakhis Special"
      style={{ width: "100%", height: "100vh", border: "none" }}
    />
  );
};

export default SakhisSpecial;


// import Header from "../Header";


// const SakhisSpecial = () => {
//   return (
//     <div style={{ backgroundColor: "#f7f8ff", minHeight: "100vh" }}>
//       {/* HEADER */}
//       <Header/>

//       {/* MAIN CONTENT */}
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           height: "70vh",
//           textAlign: "center",
//           flexDirection: "column"
//         }}
//       >

//         <h1
//           style={{
//             fontSize: "4rem",
//             fontWeight: "800",
//             letterSpacing: ".5px",
//             color: "#1b1f3b",
//             fontFamily: "'Poppins', sans-serif",
//             textShadow: "0px 4px 10px rgba(0,0,0,0.2)"
//           }}
//         >
//           ✨ Sakhis Special ✨
//         </h1>

//         <h2
//           style={{
//             marginTop: "10px",
//             fontSize: "2rem",
//             fontWeight: "600",
//             color: "#3a4ba7",
//             fontFamily: "'Poppins', sans-serif"
//           }}
//         >
//          लवकरच...
//         </h2>

//       </div>

    
//     </div>
//   );
// };

// export default SakhisSpecial;



